import { defineMessages } from 'react-intl';

export const carrierDeliveryInfoMessages = defineMessages({
  dialogHeadline: {
    defaultMessage: 'Speditionsversand',
    id: 'carrierDeliveryMessage.dialog.headline',
  },
  carrierDeliveryL: {
    defaultMessage:
      'Artikel wird <link>bis zur Grundstücksgrenze</link> geliefert (nur bei LKW-befahrbarer Straße)',
    description: 'hint text for carrier delivery to location',
    id: 'carrierDeliveryMessage.l',
  },
  carrierDeliveryS: {
    defaultMessage: 'wird per <link>Spedition</link> geliefert',
    description: 'hint text for carrier delivery',
    id: 'carrierDeliveryMessage.s',
  },
});
